// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"12":"bec0f7e1bb1e54ea41d7","777":"6b2f73a6cdb02e31acee"}[chunkId] + ".js";
};